import React, { Component } from "react";
import { Image, Responsive, Icon, Button, Segment, Header, Grid, Form, Popup, Label } from "semantic-ui-react";
import SecondaryBlueButton from "components/Buttons/SecondaryBlueButton";
import { MapInteractionCSS } from "components/MapInteraction";
import { Field, Formik } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import { isMobile } from "utils/isMobile";

class FilePreview extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fileIndex: props.fileIndex ?? 0,
			validationStep: 0,
			rotation: "0deg",
		};
	}

	componentDidMount() {
		const { fileIndex } = this.state;
		const { files } = this.props;
		if (files[fileIndex] && files[fileIndex].fromSafeplace && !files[fileIndex].barcode) {
			if (files[fileIndex].quality_validated) this.setState({ validationStep: 4 });
			else if (files[fileIndex].validated) this.setState({ validationStep: 1 });
		}
	}

	componentDidUpdate() {
		const { fileIndex } = this.state;
		const { files } = this.props;
		if (fileIndex !== 0 && fileIndex >= files?.length) {
			this.setState({ fileIndex: 0 });
		}
	}

	navigate = (next = true) => {
		let nextIndex = next ? this.state.fileIndex + 1 : this.state.fileIndex - 1;
		this.setState({
			fileIndex: nextIndex,
		});
		const { files } = this.props;
		if (files[nextIndex] && files[nextIndex].fromSafeplace && !files[nextIndex].quality_validated && !files[nextIndex].barcode)
			this.setState({ validationStep: files[nextIndex].validated ? 1 : 0 });
	};

	b64toBlob = (b64Data, contentType) => {
		var byteCharacters = atob(b64Data);

		var byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += 512) {
			var slice = byteCharacters.slice(offset, offset + 512),
				byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}
			var byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		var blob = new Blob(byteArrays, { type: contentType });
		return blob;
	};

	submitBarcode = (value) => this.props.submitBarCode(this.props.files[this.state.fileIndex].id, value);

	handleKeyDown = (event, values) => {
		if (event.key === "Enter" && values.scannedValue !== "") this.submitBarcode(values.scannedValue);
	};
	rotate = () => {
		if (this.state.rotation === "0deg") this.setState({ rotation: "90deg" });
		else if (this.state.rotation === "90deg") this.setState({ rotation: "180deg" });
		else if (this.state.rotation === "180deg") this.setState({ rotation: "270deg" });
		else if (this.state.rotation === "270deg") this.setState({ rotation: "0deg" });
	};

	render() {
		const { fileIndex, validationStep, rotation } = this.state;
		const {
			files,
			isModal = false,
			deleteScanPrescription,
			validateScanPrescription,
			validateQualityScanPrescription,
			unvalidateQualityScanPrescription,
			telesec,
			movePrescriptionScan,
			disabled,
		} = this.props;
		return (
			<>
				<div style={{ display: "flex", flexDirection: "column", width: isModal ? "100%" : "50%", height: "100%" }}>
					<Responsive
						as="div"
						style={{
							height:
								validateScanPrescription &&
								files &&
								files.length > 0 &&
								files[fileIndex] &&
								files[fileIndex].fromSafeplace &&
								!files[fileIndex].barcode &&
								validationStep === 0
									? "65vh"
									: isMobile()
									? "100%"
									: "95%",
							padding: isMobile() ? "0.5rem" : "12px 20px 0px 20px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							overflow: "auto",
							margin: "auto",
							width: "95%",
						}}
					>
						{files?.length > 0 && (
							<>
								{files[fileIndex] &&
									(files[fileIndex].type === "image/png" || files[fileIndex].type === "image/jpg" || files[fileIndex].type === "image/jpeg") && (
										<div
											style={{
												padding: isMobile() ? "5px" : "10px 50px",
												backgroundColor: "#d3d3d33b",
												//overflowY: "scroll",
												//width: isMobile() ? "300px" : "auto",
												height: "100%",
												maxHeight:
													deleteScanPrescription &&
													validateScanPrescription &&
													files[fileIndex] &&
													files[fileIndex].fromSafeplace &&
													!files[fileIndex].barcode &&
													!files[fileIndex].validated &&
													!files[fileIndex].quality_validated
														? "65vh"
														: "90vh",
											}}
										>
											<div>
												<Label ribbon>
													Document{" "}
													<Label color={files?.length > 1 ? "orange" : "grey"}>
														{" "}
														{fileIndex + 1} / {files?.length}
													</Label>
												</Label>
												{files[fileIndex].base64_back && (
													<Label as="div" color="teal">
														<Icon name="file alternate" /> Recto-verso
													</Label>
												)}
												<MapInteractionCSS   minScale={0.8} maxScale={3} showControls={true}>
													<Image
														style={{ transform: `rotate(${rotation})` }}
														src={`data:${files[fileIndex].type ?? "image/png"};charset=utf-8;base64,${files[fileIndex].base64}`}
														onContextMenu={(e) => e.preventDefault()}
													/>
												</MapInteractionCSS>
											</div>
											{files[fileIndex].base64_back && (
												<div>
													<MapInteractionCSS  minScale={1} maxScale={3} showControls={true}>
														<Image
															style={{ transform: `rotate(${rotation})` }}
															src={`data:${files[fileIndex].type ?? "image/png"};charset=utf-8;base64,${files[fileIndex].base64_back}`}
															onContextMenu={(e) => e.preventDefault()}
														/>
													</MapInteractionCSS>
												</div>
											)}
										</div>
									)}

								{files[fileIndex] && files[fileIndex].type === "application/pdf" && (
									<iframe
										id="fraDisabled"
										//Prevent download
										src={URL.createObjectURL(this.b64toBlob(files[fileIndex].base64, "application/pdf")) + "#toolbar=1"}
										// src={`data:${files[fileIndex].type};base64,${files[fileIndex].base64}`}
										title={files[fileIndex].filename}
										name={files[fileIndex].filename}
										style={{
											width: "100%",
											height:
												deleteScanPrescription &&
												validateScanPrescription &&
												files[fileIndex] &&
												files[fileIndex].fromSafeplace &&
												!files[fileIndex].barcode &&
												(!files[fileIndex].validated || !files[fileIndex].quality_validated) &&
												validationStep !== 4
													? "70vh"
													: "90vh",
										}}
									></iframe>
								)}
							</>
						)}
					</Responsive>
					<div style={{ display: "flex", justifyContent: "center" }}>
						<SecondaryBlueButton onClick={() => this.navigate(false)} disabled={!(fileIndex > 0)}>
							<Icon name="angle left" />
						</SecondaryBlueButton>

						<SecondaryBlueButton onClick={() => this.rotate()}>
							<Icon name="redo" />
						</SecondaryBlueButton>
						<SecondaryBlueButton onClick={() => this.navigate()} disabled={!(files.length - 1 > fileIndex)} style={{ margin: "0 .25em 0 5px" }}>
							<Icon name="angle right" />
						</SecondaryBlueButton>
					</div>
					{!disabled &&
						files[fileIndex] &&
						movePrescriptionScan &&
						movePrescriptionScan.active &&
						movePrescriptionScan.prescriptions
							.filter((p) => p.number !== movePrescriptionScan.current.number)
							.map((p) => (
								<div style={{ width: "100%" }} key={`assoc-${files[fileIndex].id}-${p.p.id}`}>
									<Button
										style={{ width: "100%" }}
										basic
										color="teal"
										onClick={() => movePrescriptionScan.updateScanPrescription(files[fileIndex].id, p.p.id, movePrescriptionScan.current.p.id)}
									>
										<Icon name="exchange" />
										Déplacer vers Prescription N° {p.number}
									</Button>
								</div>
							))}

					{!disabled &&
						deleteScanPrescription &&
						validateScanPrescription &&
						files[fileIndex] &&
						files[fileIndex].fromSafeplace &&
						!files[fileIndex].barcode &&
						(!files[fileIndex].validated || !files[fileIndex].quality_validated) &&
						validationStep !== 4 && (
							<div style={{ backgroundColor: "teal", color: "white", minHeight: "25vh" }}>
								{validationStep === 0 && (
									<Segment placeholder>
										<Header as="h2" textAlign="center" style={{ width: "100%" }}>
											<Header.Content>
												<Icon name="warning sign" color="red" /> Veuillez valider qu'il s'agit d'une{" "}
												<Popup
													content={
														<div>
															Validité de l'ordonnance, une ordonnance n’est pas valide si :
															<ul>
																<li>périmée ou pas encore valable</li>
																<li>date, signature ou cachet du médecin : au moins 1 élément manquant</li>
															</ul>
														</div>
													}
													trigger={
														<Label basic style={{ cursor: "help" }} size="big">
															ordonnance valide
														</Label>
													}
												/>{" "}
												<Icon name="warning sign" color="red" />
												<Header.Subheader>Cette ordonnance a été envoyée par le patient via un formulaire en ligne.</Header.Subheader>
											</Header.Content>
										</Header>
										<Segment.Inline>
											<Button
												color="red"
												onClick={async (e) => {
													e.preventDefault();
													deleteScanPrescription(files[fileIndex]);
												}}
											>
												Ordonnance NON valide
											</Button>
											<Button
												color="green"
												onClick={async (e) => {
													e.preventDefault();
													validateScanPrescription(files[fileIndex]);
													this.setState({ validationStep: 1 });
												}}
											>
												Ordonnance valide
											</Button>
										</Segment.Inline>
									</Segment>
								)}
								{validationStep === 1 && telesec && !files[fileIndex].to_be_rescan && (
									<Segment placeholder>
										<Header as="h2" textAlign="center" style={{ width: "100%" }}>
											<Header.Content>
												L’ordonnance téléchargée est-elle de{" "}
												<Popup
													content="Cette ordonnance est-elle de qualité suffisante pour être envoyée à la CNS ? "
													trigger={
														<Label basic style={{ cursor: "help" }} size="big">
															bonne qualité{" "}
														</Label>
													}
												/>{" "}
												?
											</Header.Content>
										</Header>
										<Segment.Inline style={{ display: "flex", textAlign: "baseline" }}>
											<Button
												color="red"
												style={{ margin: "10px", minHeight: "64px" }}
												onClick={async (e) => {
													e.preventDefault();
													unvalidateQualityScanPrescription(files[fileIndex]);
													this.setState({ validationStep: 4 });
												}}
											>
												{" "}
												<span style={{ textTransform: "uppercase", fontSize: "1.2em" }}>Mauvaise qualité</span> <br />{" "}
												<span style={{ fontStyle: "italic" }}>photo de l’ordonnance, peu lisible, de travers …</span>
											</Button>
											<Button
												color="green"
												style={{ margin: "10px", minHeight: "64px" }}
												onClick={async (e) => {
													e.preventDefault();
													validateQualityScanPrescription(files[fileIndex]);
													this.setState({ validationStep: 4 });
												}}
											>
												<span style={{ textTransform: "uppercase", fontSize: "1.2em" }}>Bonne qualité </span> <br />
												<span style={{ fontStyle: "italic" }}>ordonnance pdf, scan, …</span>
											</Button>
										</Segment.Inline>
									</Segment>
								)}
								{validationStep === 1 && !telesec && (
									<Segment placeholder>
										<Header as="h2" textAlign="center" style={{ width: "100%" }}>
											<Header.Content>
												{!files[fileIndex].to_be_rescan
													? "Le patient est-il venu avec une ordonnance papier ?"
													: "La qualité du document téléchargé n'est pas suffisante pour l'envoi à la CNS. Le patient est-il venu avec une ordonnance papier ?"}
											</Header.Content>
										</Header>
										<Segment.Inline>
											<Button
												color="red"
												onClick={async (e) => {
													e.preventDefault();
													this.setState({ validationStep: 2 });
												}}
											>
												Non
											</Button>
											<Button
												color="green"
												onClick={async (e) => {
													e.preventDefault();
													this.setState({ validationStep: 3 });
												}}
											>
												Oui
											</Button>
										</Segment.Inline>
									</Segment>
								)}
								{validationStep === 2 && !telesec && !files[fileIndex].to_be_rescan && (
									<Segment placeholder>
										<Header as="h2" textAlign="center" style={{ width: "100%" }}>
											<Header.Content>
												Si le patient se présente SANS ordonnance papier, l’ordonnance téléchargée est-elle de{" "}
												<Popup
													content="Cette ordonnance est-elle de qualité suffisante pour être envoyée à la CNS ? "
													trigger={
														<Label basic style={{ cursor: "help" }} size="big">
															bonne qualité{" "}
														</Label>
													}
												/>{" "}
												?
											</Header.Content>
										</Header>
										<Segment.Inline style={{ display: "flex", textAlign: "baseline" }}>
											<Button
												color="red"
												style={{ margin: "10px", minHeight: "64px" }}
												onClick={async (e) => {
													e.preventDefault();
													deleteScanPrescription(files[fileIndex]);
												}}
											>
												{" "}
												<span style={{ textTransform: "uppercase", fontSize: "1.2em" }}>Mauvaise qualité</span> <br />{" "}
												<span style={{ fontStyle: "italic" }}>photo de l’ordonnance, peu lisible, de travers …</span>
											</Button>
											<Button
												color="green"
												style={{ margin: "10px", minHeight: "64px" }}
												onClick={async (e) => {
													e.preventDefault();
													validateQualityScanPrescription(files[fileIndex]);
													this.setState({ validationStep: 4 });
												}}
											>
												<span style={{ textTransform: "uppercase", fontSize: "1.2em" }}>Bonne qualité </span> <br />
												<span style={{ fontStyle: "italic" }}>ordonnance pdf, scan, …</span>
											</Button>
										</Segment.Inline>
									</Segment>
								)}
								{validationStep === 3 && !telesec && this.props.submitBarCode && (
									<Segment placeholder>
										<Header icon>
											<Icon name="barcode" />
											<span style={{ fontSize: "0.9em" }}>
												Veuillez scanner le code-barres de l'ordonnance et rescanner le document pour GesLab :{" "}
											</span>{" "}
											<br />
											<Formik
												enableReinitialize
												initialValues={{
													scannedValue: "",
												}}
												onSubmit={(values) => {
													this.submitBarcode(values.scannedValue);
												}}
											>
												{({ values, submitForm }) => (
													<Grid columns={1} stackable textAlign="center">
														<Grid.Row>
															<Grid.Column>
																<Form style={{ display: "flex", justifyContent: "center" }}>
																	<Field
																		component={CustomInputTextComponent}
																		autoFocus
																		autoComplete="off"
																		customlabel="Code-barres du document"
																		type="text"
																		name="scannedValue"
																		onKeyDown={(e) => this.handleKeyDown(e, values)}
																		style={{ maxWidth: "200px" }}
																	/>
																</Form>
															</Grid.Column>
														</Grid.Row>
														<Grid.Row style={{ paddingTop: 0 }}>
															<Grid.Column style={{ display: "flex", justifyContent: "center", margin: 0 }}>
																<Button
																	style={{ margin: "3px 10px" }}
																	onClick={(e) => {
																		if (e !== undefined) e.preventDefault();
																		this.setState({ validationStep: 1 });
																	}}
																>
																	Annuler
																</Button>
																<Button
																	style={{ margin: "3px" }}
																	primary
																	type="submit"
																	onClick={(e) => {
																		if (e !== undefined) e.preventDefault();
																		this.submitBarcode(values.scannedValue);
																		this.setState({ validationStep: 4 });
																	}}
																	disabled={values.scannedValue.length !== 10 && values.scannedValue.length !== 12}
																>
																	Confirmer
																</Button>
															</Grid.Column>
														</Grid.Row>
													</Grid>
												)}
											</Formik>
										</Header>
									</Segment>
								)}
							</div>
						)}
				</div>
			</>
		);
	}
}

export default FilePreview;
